<:Window on:resize='resize()' />

<Slide :slide :i>

    <div class="i-pro step-{{ step }}">

        {{#each slide.text_list as text_item, n}}
        <div class="slide__text slide__text--{{ n + 1 }} slide__text--interactive step">
            <p class="slide__text-inner">{{ text_item }}</p>
        </div>
        {{/each}}

        {{#if slide.footnote}}
        <div class="i-pro__footnote">{{ slide.footnote }}</div>
        {{/if}}

        <div class="media-outer interactive i-pro__video">
            <video muted loop playsinline ref:video>
                <source src="{{ video('slr_projections.webm') }}" type="video/webm">
                <source src="{{ video('slr_projections.mp4') }}" type="video/mp4">
            </video>
        </div>
        <div class="media-outer interactive i-pro__img">
            <img alt="SLR projections" src="img/slr_projections.jpg" />
        </div>

        <div ref:chart class="chart i-pro__chart">
            
            <div class="years i-pro__years">
                <span class="number i-pro__number">
                    {{ years.toFixed() }}
                </span>
                years
            </div>

            <svg ref:svg class="i-pro__timeline">

                <g transform="translate({{ pad.left }}, {{ pad.top }})" transition:fade>
                    <rect class="background"
                        x="{{ x(start) }}"
                        y="{{ height * 3/4 }}"
                        width="{{ Math.max(width, 0) }}"
                        height="{{ height / 4 }}"></rect>

                    <rect class="years"
                        x="{{ x(start) }}"
                        y="{{ height * 3/4 }}"
                        width="{{ Math.max(x(end), 0) }}"
                        height="{{ height / 4 }}"></rect>
                    <text text-anchor="middle" x="{{ x(start) }}" y="{{ height / 2 }}">{{ start.toFixed() }}</text>
                    <line class="tick" 
                        x1="{{ x(start) }}" 
                        x2="{{ x(start) }}" 
                        y1="{{ height * 2/3 }}"
                        y2="{{ height }}"></line>

                    <text text-anchor="middle" x="{{ x(end) }}" y="{{ height / 2 }}">{{ end.toFixed() }}</text>
                    <line class="tick" 
                        x1="{{ x(end) }}" 
                        x2="{{ x(end) }}" 
                        y1="{{ height * 2/3 }}"
                        y2="{{ height }}"></line>
                </g>

            </svg>
            
            <div class="label i-pro__label">
                before major annual floods
            </div>
        </div>

    </div>

</Slide>

<script>
import Slide from '../Slide.html'
import { media, video, noop, syncCues } from '../helpers'

import { scaleLinear } from 'd3-scale'
import { tween } from 'svelte-extras'
import { fade } from 'svelte-transitions'

export default {

    components: {
        Slide,
    },

    transitions: {
        fade,
    },

    data() {
        return {
            slug: 'slr-projections',
            i: 0,

            // years until flooding
            start: 2018,
            goal: 2083,
            end: 2018, // for tweening

            projections: [38, 60, 65],

            // sizing
            width: 0,
            height: 0,
            pad: {top: 0, right: 20, bottom: 0, left: 20},

            show_chart: false,
        }
    },

    computed: {
        years: (start, end) => end - start,

        x: (width, pad, start, goal) => scaleLinear()
            .domain([start, goal])
            .range([0, width]),
    },

    oncreate() {
        window.slrproj = this;

        this.observers = [];

        this.observers.push(this.store.observe('bullet', current => {
            const [slide, bullet] = (current || []);
            const i = this.get('i');

            // set step regardless
            if (slide < i) {
                this.set({ step: 'before' });
            } else if (slide > i) {
                this.set({ step: 'after' });
            } else {
                this.set({ step: bullet });
            }

            // only run here
            if (slide !== i) return;

            const { projections, start } = this.get();
            const delay = 1000;

            if (bullet === 2) {

                this.tween('end', start + projections[2], {
                    delay,
                    duration: 800
                });
            }

            if (bullet === 5) {

                this.tween('end', start + projections[1], {
                    delay,
                });
            }

            if (bullet === 8) {

                this.tween('end', start + projections[0], {
                    delay,
                })
            }

        }));

        this.observers.push(this.store.observe('current_slide', current => {

            if (current === this.get('i')) {
                this.play();
            } else {
                this.pause();
            }
        }));

        this.observers.push(this.store.observe('index_active', current => {
            if (current) {
                this.pause();
            } else if ( this.store.get('current_slide') == this.get('i') ) {
                this.play();
            }
        }));

        syncCues(this.refs.track, this.refs.display);
        
        this.resize();
    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel()
        }
    },

    methods: {

        tween, 

        resize() {
            const { width, height } = this.refs.svg.getBoundingClientRect();
            const pad = this.get('pad');
            this.set({ 
                width: width - pad.right - pad.left, 
                height: height - pad.top - pad.bottom
            });
        },

        play() {
            const { video, audio } = this.refs;
            this.set({ show_controls: false, show_visuals: false });
            
            video && video.play().catch(noop);
            audio && audio.play().catch(noop);
        },
        pause() {
            const { video, audio } = this.refs;

            video && video.pause();
            audio && audio.pause();
        }
    },

    helpers: {
        media,
        video,
    }

}
</script>